import * as React from "react";
import * as _ from "lodash";
import { ToggleBox } from "../../components/ToggleBox/ToggleBox";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import {
  ISubWebGlobalSearchProps,
  ISubWebGlobalSearchState,
  SearchModel,
  ResultItem,
  TermCount,
  CategoryItem,
} from "./SubWebGlobalSearch.types";
import { sendQueryToServer } from "../../utils/sendQueryToServer";
import { ContentPagination } from "../../components/ContentPagination/ContentPagination";
import { formatString } from "../../utils/helpers";
import { makeTranslator } from "../../utils/translations";
import { SelectBox } from "../FormControls/SelectBox";

let Translate: (key: string, defaultValue?: string) => string;

export class SubWebGlobalSearch extends React.Component<
  ISubWebGlobalSearchProps,
  ISubWebGlobalSearchState
> {
  private _isPageChange: boolean;
  private _queue: NodeJS.Timeout[] = [];
  private url = "/_api/search";
  private searchModel: SearchModel;
  static defaultProps = {
    searchSectionsLabel: "Filtrera på typ av innehåll",
    filtersLabel: "Filtrera på områden",
  };

  constructor(props: ISubWebGlobalSearchProps) {
    super(props);
    Translate = makeTranslator(props.translations);
    this.state = {
      currentSearchState: this.createInitialSearchState(),
      relevansbuttonIsActive: true,
      sortbuttonIsActive: false,
      amneopen: false,
      productopen: false,
      filteropen: false,
      isSearching: false,
      searchResultModel: _.cloneDeep(this.props.initalSearchResultModel),
      isDataLoading: false,
      isError: false,
      showFilter: false,
    };
  }
  componentDidMount() {
    this.searchModel = this.state.currentSearchState;
    var checkbox = document.querySelectorAll(
      "input[type='checkbox'][value='Allt innehåll']"
    );
    if (checkbox.length > 0) {
      var radioButton = checkbox[0] as HTMLInputElement;
      radioButton.checked = true;
    }
  }
  componentDidUpdate(
    prevProps: ISubWebGlobalSearchProps,
    prevState: ISubWebGlobalSearchState
  ) {
    if (_.isEqual(prevState.currentSearchState, this.state.currentSearchState))
      return;
    this.searchModel = this.state.currentSearchState;
    //do not delay if it's a page change
    if (this._isPageChange) {
      this._isPageChange = false;
      this.setState({ isDataLoading: true });
      sendQueryToServer(this.url, this.state.currentSearchState)
        .then((response) => {
          this.setState({
            searchResultModel: response,
            isDataLoading: false,
            isError: false,
          });
        })
        .catch((response) => {
          this.handleError();
        });
    } else {
      this.delay(500).then((_) => {
        this.setState({ isDataLoading: true });
        sendQueryToServer(this.url, this.state.currentSearchState)
          .then((response) => {
            this.setState({
              searchResultModel: response,
              isDataLoading: false,
              isError: false,
            });
          })
          .catch((response) => {
            this.handleError();
          });
      });
    }
  }
  handleError = () => {
    this.setState({
      isError: true,
    });
  };

  onShowHideFilter = () => {
    this.setState({
      showFilter: !this.state.showFilter,
    });
  };
  private renderDidYouMean = () => {
    const didYouMean = this.state.searchResultModel.DidYouMean || [];

    return (
      <div className="search-result__suggestion">
        {didYouMean.length > 0 && <p>{Translate("didYouMean")} </p>}
        {didYouMean.map((sugge, i) => (
          <li key={i}>
            <a href={`${this.props.searchPageLink}?q=${sugge.Suggestion}`}>
              {sugge.Suggestion}
            </a>
          </li>
        ))}
      </div>
    );
  };
  delay = (interval: number) => {
    return new Promise((resolve) => {
      let item = setTimeout(resolve, interval);
      this._queue.push(item);
      while (this._queue.length > 1) {
        let toClear = this._queue.shift();
        clearTimeout(toClear);
      }
    });
  };
  /**
   * Construct the initial SearchModel object. Some values are predefined whereas some are dependent on the props.
   * This is the model which is being sent to the backend on change of search parameters (query, categoeies, filters etc.).
   * Make sure to **cloneDeep** this object with lodash when updating the state because it has nested objects.
   */
  createInitialSearchState = (): SearchModel => {
    let model: SearchModel = {
      PageNo: 1,
      Query: this.props.initalSearchResultModel.Query,
      FilterList: [],
      SearchSections: [],
      IsDocument: false,
      PageSize: this.props.pageSize,
      CurrentPageId: this.props.currentPageId,
    };

    return model;
  };
  setNewPage = (newPage: number) => {
    const { currentSearchState } = this.state;
    let searchStateClone = _.cloneDeep(currentSearchState);
    searchStateClone.PageNo = newPage;

    this._isPageChange = true;

    document.body.scrollTop = 50; // For Safari
    document.documentElement.scrollTop = 50;

    this.setState({
      currentSearchState: searchStateClone,
    });
  };
  arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele != value;
    });
  };

  addToOrRemoveFromArray = (arr, val) => {
    const index = arr.indexOf(val);

    if (index === -1) {
      //elem not found, add
      arr.push(val);
    } else {
      arr = this.arrayRemove(arr, val);
    }
    return arr;
  };
  checkItem = (e: any) => {
    const { currentSearchState } = this.state;
    const { filters, searchSections } = this.props;
    var searchStateClone = _.cloneDeep(currentSearchState);
    const hasCurrentTarget = e.hasOwnProperty("currentTarget");

    //set MandatoryCategories and StandardCategories according to the incoming values
    const value = hasCurrentTarget ? e.currentTarget.value : e.value;
    const selectedarea = filters.find((x) => x.Id.toString() === value);
    const selectedTerm = searchSections.find((x) => x.Term === value);

    //clear filters in mobile dropdown
    if (!hasCurrentTarget && selectedarea) {
      searchStateClone.FilterList = [];
    }
    //clear sections in mobile dropdown
    if (!hasCurrentTarget && selectedTerm) {
      searchStateClone.SearchSections = [];
    }

    if (selectedarea) {
      searchStateClone.FilterList = this.addToOrRemoveFromArray(
        searchStateClone.FilterList,
        selectedarea.Id
      );
    } else if (selectedTerm) {
      searchStateClone.SearchSections = this.addToOrRemoveFromArray(
        searchStateClone.SearchSections,
        selectedTerm.Term
      );
    }
    if (value === "") {
      searchStateClone.FilterList = [];
    }

    //Unselect and remove "Allt innehåll" if any other section is selected
    if (hasCurrentTarget) {
      if (value !== "Allt innehåll") {
        var checkbox = document.querySelectorAll(
          "input[type='checkbox'][value='Allt innehåll']"
        );
        if (checkbox.length > 0) {
          var radioButton = checkbox[0] as HTMLInputElement;
          radioButton.checked = false;
        }
        var itemToRemove = "Allt innehåll";
        for (var i = searchStateClone.SearchSections.length - 1; i >= 0; i--) {
          if (searchStateClone.SearchSections[i] === itemToRemove) {
            searchStateClone.SearchSections.splice(i, 1);
          }
        }
      }
      //Unselect and remove all other sections if "Allt innehåll" is selected
      else if (value === "Allt innehåll") {
        var checkboxes = document.querySelectorAll(
          "div.sections input[type='checkbox']"
        );
        for (var i = searchStateClone.SearchSections.length - 1; i >= 0; i--) {
          if (searchStateClone.SearchSections[i] !== value) {
            searchStateClone.SearchSections.splice(i, 1);
          }
        }
        if (checkboxes.length > 0) {
          for (var i = checkboxes.length - 1; i >= 0; i--) {
            var radioButton = checkboxes
              ? (checkboxes[i] as HTMLInputElement)
              : null;
            if (radioButton != null && radioButton.value !== "Allt innehåll") {
              radioButton.checked = false;
            }
          }
        }
      }
      var CheckDefaultOption =
        searchStateClone.SearchSections.length === 0 ||
        value === "Allt innehåll"
          ? true
          : false;
      this.CheckDefaultSectionOption(CheckDefaultOption);

      if (this.RemoveExtraFilters() && hasCurrentTarget) {
        searchStateClone.FilterList = [];
      }
    }

    searchStateClone.PageNo = 1;

    this.setState({
      currentSearchState: searchStateClone,
    });
  };

  RemoveExtraFilters = () => {
    var checkboxes = document.querySelectorAll(
      "#area-filters input[type='checkbox']"
    );
    var checkedItems = [];
    if (checkboxes.length > 0) {
      for (var i = checkboxes.length - 1; i >= 0; i--) {
        var radioButton = checkboxes
          ? (checkboxes[i] as HTMLInputElement)
          : null;
        if (radioButton.checked) {
          checkedItems.push(radioButton);
        }
      }
    }

    return checkedItems.length > 0 ? false : true;
  };

  CheckDefaultSectionOption = (checkDefaultOption) => {
    if (checkDefaultOption) {
      var checkbox = document.querySelectorAll(
        "input[type='checkbox'][value='Allt innehåll']"
      );
      if (checkbox.length > 0) {
        var radioButton = checkbox[0] as HTMLInputElement;
        radioButton.checked = true;
      }
    }
  };

  SelectedItems = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { filters } = this.props;
    var searchStateClone = _.cloneDeep(this.searchModel);

    const value = e.currentTarget.value;
    const selectedFilter = filters.find((x) => x.Id.toString() === value);

    if (selectedFilter) {
      searchStateClone.FilterList = this.addToOrRemoveFromArray(
        searchStateClone.FilterList,
        selectedFilter.Id
      );
    }
    searchStateClone.PageNo = 1;

    this.searchModel = searchStateClone;
  };
  setFilters = () => {
    this.setState({
      currentSearchState: this.searchModel,
    });
  };

  //Render item
  private renderItem = (item: ResultItem, index: number): JSX.Element => {
    const { currentLanguage } = this.props;
    const breadCrumbs = item.SearchResultsBreadCrumbs || [];
    let deviantLanguage = null;
    if (currentLanguage && currentLanguage !== item.LanguageCode) {
      deviantLanguage = item.LanguageCode;
    }
    return (
      <li key={index} lang={deviantLanguage} className="search-result__item">
        <h3>
          <a className={item.Type} href={item.Url}>
            {item.Title}
          </a>
        </h3>

        {item.Type === null &&
          item.MainText != "" &&
          item.ItemType != "Dokument" && (
            <div className="search-result__text">{item.MainText}</div>
          )}
        {!item.BestBetsExternalLink && !this.props.hideDate && (
          <div className={`search-result__date ${item.DateClassModifier}`}>
            {" "}
            {Translate("lastUpdateDate")} {item.StartDate}{" "}
          </div>
        )}
        {item.Publisher != null && item.PublishDate && (
          <span className="search-result__publisher">
            {item.Publisher}{" "}
            {item.PublishDate
              ? new Date(item.PublishDate).toLocaleDateString("sv-SE")
              : ""}
          </span>
        )}
        {this.props.showBreadCrumbs && (
          <ol
            className="search-result__breadcrumbs"
            aria-label={Translate("ariaBreadcrumbs")}
          >
            {item.LanguageCode && (
              <li>
                <a href={item.StartPageExternalUrl}> {item.LanguageCode}</a>
              </li>
            )}
            <li>
              <a href={item.StartPageExternalUrl}> {item.StartPageName}</a>
            </li>

            {breadCrumbs.map((breadcrumb, i) => (
              <li key={i}>
                <a href={breadcrumb.Url}>{breadcrumb.Name}</a>
              </li>
            ))}

            {item.StartPageName != null && (
              <li>
                <a href={item.Url}>{item.Title}</a>
              </li>
            )}
          </ol>
        )}
      </li>
    );
  };

  getSelectFiltersBoxItems = (categories: CategoryItem[]) => {
    let selectBoxItems = [];
    if (!categories) return selectBoxItems;
    for (var cat of categories) {
      var selectboxItem = { key: cat.Id, text: cat.Name };
      selectBoxItems.push(selectboxItem);
    }
    return selectBoxItems;
  };

  getSearchSectionsBoxItems = (terms: TermCount[]) => {
    let selectBoxItems = [];
    if (!terms) return selectBoxItems;
    for (var term of terms) {
      var selectboxItem = {
        key: term.Term,
        text: term.Term,
        count: term.Count,
      };
      selectBoxItems.push(selectboxItem);
    }
    return selectBoxItems;
  };

  render(): JSX.Element {
    //Update the number of filterd result
    const { isDataLoading, isError, searchResultModel } = this.state;
    const { searchSections, filters, pageSize } = this.props;
    const selectSearchSectionsBoxItems = this.getSearchSectionsBoxItems(
      this.props.searchSections
    );
    const selectFiltersBoxItems = this.getSelectFiltersBoxItems(
      this.props.filters
    );
    return (
      <React.Fragment>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {searchSections && searchSections.length > 0 && (
                <>
                  {this.renderCheckbox()}
                  <div className="d-block d-md-none search-result__select-box-container">
                    <SelectBox
                      options={selectSearchSectionsBoxItems}
                      onChange={this.checkItem}
                      id="select-section-filter"
                      disableDefaultOption={true}
                      fieldName="section-select"
                      label={this.props.searchSectionsLabel}
                    />
                  </div>
                </>
              )}
              {filters && filters.length > 0 && (
                <div
                  id="area-filters"
                  className={
                    "search-result__details-content search-result__more-filter d-none" +
                    (this.state.showFilter ? " d-md-flex" : "")
                  }
                >
                  <fieldset>
                    <legend className="sr-only">
                      {Translate("categories")}
                    </legend>
                    <div className="d-flex flex-wrap">
                      {filters.map((category, i) => {
                        return (
                          <ToggleBox
                            key={`searchfilterbox-${i}`}
                            label={category.Name}
                            value={category.Id.toString()}
                            cssClass=""
                            onChangeCb={this.SelectedItems}
                          />
                        );
                      })}
                    </div>
                  </fieldset>
                  <button
                    className="button search-result__button"
                    onClick={this.setFilters}
                    type="button"
                  >
                    {Translate("updateSearch")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {isError && (
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="search-result__no-results">
                  {Translate("tryAgainLater")}
                </div>
              </div>
            </div>
          </div>
        )}
        {!isError && (
          <div className="search-result__results-wrapper">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="search-result__info">
                    <div
                      className="search-result__info-heading"
                      aria-live="polite"
                      aria-atomic="true"
                    >
                      {formatString(
                        Translate("showingXofYresults"),
                        searchResultModel.ResultItems.length.toString(),
                        searchResultModel.TotalHits.toString()
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-10">
                  {isDataLoading && <LoadingSpinner darkColor={true} />}
                </div>
                <div className="col-lg-10">
                  <div className="search-result__result">
                    {searchResultModel.DidYouMean.length > 0
                      ? this.renderDidYouMean()
                      : null}
                    <ContentPagination
                      data={searchResultModel.ResultItems.map(this.renderItem)}
                      pageSize={pageSize}
                      pageCount={Math.ceil(
                        searchResultModel.TotalHits / pageSize
                      )}
                      onChangePageCb={this.setNewPage}
                      noResultText={Translate("filterNoResult")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  //Render the whole checkbox list
  private renderCheckbox = (): JSX.Element => {
    const { filters, searchSections } = this.props;
    return (
      <div className="page-list d-none d-md-block">
        <span className="filters__filter-text">{Translate("filterBy")}</span>
        <div className="search-result__container">
          <div className="search-result__filters page-list__filters filters search-result__filter-item-wrapper search-result--filter-content-items">
            <div className="search-result__filter-categories">
              <fieldset>
                {searchSections.length > 0 && (
                  <legend className="filters__filter-text sr-only">
                    {Translate("filterByContent")}
                  </legend>
                )}
                <div className="search-result__filter-item">
                  {searchSections
                    ? searchSections.map((term, i) => {
                        return (
                          <ToggleBox
                            key={`operationsbox-${i}`}
                            label={term.Term}
                            value={term.Term}
                            cssClass="sections"
                            onChangeCb={this.checkItem}
                            termCount={term.Count}
                          />
                        );
                      })
                    : null}
                </div>
              </fieldset>
            </div>
          </div>
          {filters && filters.length > 0 && (
            <button
              aria-controls="area-filters"
              aria-expanded={this.state.showFilter}
              id="accordion-control-1"
              onClick={this.onShowHideFilter}
              className={
                "button search-result__expand-filter-button expand-filter__plusminus" +
                (this.state.showFilter
                  ? " search-result--filter-button-expanded"
                  : "")
              }
            >
              {Translate("moreFilters")}
            </button>
          )}
        </div>
      </div>
    );
  };
}
